import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetCourseSettingsFromEntityUseCaseInterface } from 'domain/usecases';

export class RemoteGetCourseSettingsFromEntity
  implements GetCourseSettingsFromEntityUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetCourseSettingsFromEntityUseCaseInterface.Params,
  ): Promise<GetCourseSettingsFromEntityUseCaseInterface.Result> {
    const requestUrl = `${this.url}/${params.id}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
